import {
  BOAT_RACE_IMAGES,
  BOAT_RACE_REFERENCE_LINKS_ML,
  BOAT_RACE_STREAMING_CHANNELS_NEWS,
  BOAT_RACE_STREAMING_CHANNELS_PUBLIC,
  BOAT_RACE_STREAMING_CHANNELS_TOURISM,
} from './boatRacePostUtils';

const CHANNEL_COUNT =
  BOAT_RACE_STREAMING_CHANNELS_PUBLIC.length +
  BOAT_RACE_STREAMING_CHANNELS_NEWS.length +
  BOAT_RACE_STREAMING_CHANNELS_TOURISM.length;

/** മലയാളം — കേരള വള്ളംകളി സൗജന്യ YouTube ലൈവ് സ്ട്രീമിംഗ് ഗൈഡ് */
const STREAMING_CHANNELS_PUBLIC_ML = BOAT_RACE_STREAMING_CHANNELS_PUBLIC.map((item, index) => {
  const ml = [
    {
      title: 'DD മലയാളം ലൈവ്',
      channel: 'DD മലയാളം (ദൂരദർശൻ)',
      description:
        'പ്രധാന മലയാളം പൊതുസംപ്രേഷണ ടെലികാസ്റ്റ് — ഹീറ്റുകൾ ~2:00 PM മുതൽ, ചുണ്ടൻ ഫൈനൽ ഉച്ചയ്ക്ക് ശേഷം.',
    },
    {
      title: 'ദൂരദർശൻ നാഷണൽ',
      channel: 'DD നാഷണൽ',
      description:
        'ദേശീയ ദൂരദർശൻ ഫീഡ് — പുന്നമടയിൽ നെഹ്‌റു ട്രോഫി ലൈവ് സ്ട്രീമുകൾ പല വർഷങ്ങളിൽ DD മലയാളത്തോടൊപ്പം.',
    },
  ];
  return { ...item, ...ml[index] };
});

const STREAMING_CHANNELS_NEWS_ML = BOAT_RACE_STREAMING_CHANNELS_NEWS.map((item, index) => {
  const ml = [
    {
      title: 'Asianet News ലൈവ്',
      channel: 'Asianet News',
      description: 'പ്രധാന കേരള ന്യൂസ് നെറ്റ്വർക്ക് — NTBR ലൈവ്, മലയാളം കമന്ററി, അതേ ദിവസം ഹൈലൈറ്റുകൾ.',
    },
    {
      title: 'Manorama News ലൈവ്',
      channel: 'Manorama News',
      description: 'മലയാള മനോരമ ന്യൂസ് — മത്സര ദിവസം പൂർണ്ണ കവറേജ്, ചുണ്ടൻ ഫൈനൽ ഹൈലൈറ്റുകൾ YouTube-ൽ.',
    },
    {
      title: '24 News ലൈവ്',
      channel: '24 News (Twenty Four)',
      description:
        'Twenty Four News — ഷൈജു ദാമോദരനും ഐപ്പ് വള്ളികാടനും പല സീസണുകളിൽ NTBR കമന്ററി നയിച്ചിട്ടുണ്ട്.',
    },
    {
      title: 'Mathrubhumi Live',
      channel: 'Mathrubhumi News',
      description: 'മാതൃഭൂമി ന്യൂസ് ലൈവ് YouTube — NTBR ലൈവ് വിൻഡോകളും വള്ളംകളി അപ്ഡേറ്റുകളും.',
    },
    {
      title: 'Kairali News ലൈവ്',
      channel: 'Kairali News',
      description: 'കൈരളി ടിവി ന്യൂസ് — ഓണം കാലത്തെ വള്ളംകളി ലൈവ് സ്ട്രീമുകളും തീരത്ത് റിപ്പോർട്ടുകളും.',
    },
    {
      title: 'MediaOne ലൈവ്',
      channel: 'MediaOne',
      description: 'MediaOne മലയാളം ന്യൂസ് — NTBR-യും പ്രാദേശിക വള്ളംകളിയും മഴക്കാലം കലണ്ടറിലൂടെ.',
    },
    {
      title: 'News18 Kerala ലൈവ്',
      channel: 'News18 Kerala',
      description: 'Network18 കേരള ഫീഡ് — മത്സര ദിവസം YouTube ലൈവ്, വിശ്ലേഷണം.',
    },
    {
      title: 'Reporter LIVE',
      channel: 'Reporter TV',
      description: 'Reporter നെറ്റ്വർക്ക് ലൈവ് ഫീഡ് — നെഹ്‌റു ട്രോഫി വീക്കെൻഡ് ഉൾപ്പെടെ പ്രധാന വള്ളംകളികൾ.',
    },
    {
      title: 'Janam TV Live',
      channel: 'Janam Media',
      description: 'Janam TV ഔദ്യോഗിക YouTube — NTBR-യും മറ്റ് വള്ളംകളി ഇവന്റുകളും നെറ്റ്വർക്കിൽ ഉള്ളപ്പോൾ.',
    },
    {
      title: 'Raj News Malayalam',
      channel: 'Raj News Malayalam',
      description: 'Raj News മലയാളം YouTube — പ്രാദേശിക മത്സര കവറേജും ഹൈലൈറ്റ് പാക്കേജുകളും.',
    },
  ];
  return { ...item, ...ml[index] };
});

const STREAMING_CHANNELS_TOURISM_ML = BOAT_RACE_STREAMING_CHANNELS_TOURISM.map((item, index) => {
  const ml = [
    {
      title: 'Champions Boat League',
      channel: 'CBL — കേരള ടൂറിസം',
      description:
        'ഔദ്യോഗിക CBL ചാനൽ — NTBR ലീഗ് ഉദ്ഘാടനം, കേരളത്തിലെ CBL വേദി മത്സരങ്ങൾ (ലൈവ്/ഹൈലൈറ്റ്).',
    },
    {
      title: 'Kerala Tourism',
      channel: 'കേരള ടൂറിസം',
      description: 'സംസ്ഥാന ടൂറിസം ബോർഡ് — പ്രമോ ഫിലിമുകൾ, മത്സര കലണ്ടർ, CBL ഹൈലൈറ്റുകൾ.',
    },
  ];
  return { ...item, ...ml[index] };
});

export const KERALA_BOAT_RACE_STREAMING_MALAYALAM_POST = {
  id: 'featured-kerala-boat-race-streaming-malayalam',
  slug: 'kerala-boat-race-live-stream-youtube-malayalam',
  title: 'കേരള വള്ളംകളി ലൈവ്: സൗജന്യ YouTube ചാനലുകൾ — NTBR & വള്ളംകളി',
  excerpt:
    '72-ാം നെഹ്‌റു ട്രോഫിയും കേരള വള്ളംകളിയും YouTube-ൽ സൗജന്യം — DD മലയാളം, Asianet, Manorama, 24 News, എല്ലാ പ്രധാന മലയാളം ന്യൂസ് ചാനലുകളുടെ ലിങ്കുകൾ ഒരിടത്ത്.',
  publishedAt: '2026-08-22T01:00:00.000Z',
  coverImageUrl: BOAT_RACE_IMAGES.hero,
  authorName: 'Daily Sports Life',
  clubName: 'കേരള കായിക വാർത്താ ഡെസ്ക്',
  audience: 'മലയാളി പ്രേക്ഷകർ',
  blogCategory: 'boat-races',
  locale: 'ml',
  boatRaceTopic: 'streaming',
  alternateSlug: 'kerala-boat-race-live-stream-youtube-channels',
  featured: true,
  pinned: true,
  component: 'WellnessGuideBlogArticle',
  theme: 'diet',
  relatedPostsTitle: 'ബന്ധപ്പെട്ട വള്ളംകളി ലേഖനങ്ങൾ',
  relatedPosts: [
    {
      slug: 'kerala-boat-race-live-stream-youtube-channels',
      title: 'Kerala Boat Race Live Stream: Free YouTube Channels (English)',
      blurb: 'ഇംഗ്ലീഷ് പതിപ്പ് — അതേ ചാനൽ ലിസ്റ്റ്.',
    },
    {
      slug: 'nehru-trophy-2026-chundan-vallam-malayalam',
      title: '72-ാം നെഹ്‌റു ട്രോഫി 2026: ചുണ്ടൻ വള്ളങ്ങൾ, ക്ലബുകൾ, കാപ്റ്റൻമാർ',
      blurb: 'ചുണ്ടൻ പട്ടിക, കാപ്റ്റൻ വിവരങ്ങൾ, ഫോട്ടോകൾ.',
    },
    {
      slug: 'kerala-boat-race-nehru-trophy-ntbr-malayalam',
      title: 'കേരള വള്ളംകളി ഗൈഡ്: NTBR 2026 & നെഹ്‌റു ട്രോഫി ചരിത്രം',
      blurb: 'ചരിത്രം, സന്ദർശകർക്കുള്ള നുറുങ്ങുകൾ.',
    },
  ],
  referenceLinks: [
    ...BOAT_RACE_REFERENCE_LINKS_ML,
    {
      label: 'NIC വെബ്കാസ്റ്റ് (webcast.gov.in)',
      url: 'https://webcast.gov.in/nehrutrophy/',
    },
    {
      label: 'NTBR ഔദ്യോഗിക വീഡിയോ ഗാലറി',
      url: 'https://nehrutrophy.nic.in/pages-en-IN/videos-index.php',
    },
  ],
  sections: [
    {
      type: 'stats',
      ariaLabel: 'സ്ട്രീമിംഗ് ഗൈഡ് സംക്ഷിപ്തം',
      items: [
        { value: String(CHANNEL_COUNT), label: 'സൗജന്യ YouTube ചാനലുകൾ' },
        { value: '22 ഓഗ 2026', label: '72-ാം നെഹ്‌റു ട്രോഫി (ഇന്ന്)' },
        { value: '11 AM–5 PM', label: 'സാധാരണ NTBR സമയം (IST)' },
        { value: '₹0', label: 'YouTube — സബ്സ്ക്രിപ്ഷൻ വേണ്ട' },
      ],
    },
    {
      type: 'panel',
      title: 'കേരള വള്ളംകളി YouTube-ൽ സൗജന്യം കാണാൻ',
      paragraphs: [
        'വിദേശത്ത് നിന്നും **കേരള വള്ളംകളി** കാണാൻ കേബിൾ ബോക്സ് വേണ്ട. ഓഗസ്റ്റ്–ഓണം കാലത്ത് മലയാളം ന്യൂസ് നെറ്റ്വർക്കുകളും ദൂരദർശനും **നെഹ്‌റു ട്രോഫി ബോട്ട് റേസ് (NTBR)** ഔദ്യോഗിക **YouTube** ചാനലുകളിൽ ലൈവ് സ്ട്രീം ചെയ്യുന്നു — ഫോൺ, ലാപ്ടോപ്പ്, സ്മാർട്ട് ടിവിയിൽ സൗജന്യം.',
        '**2026 ഓഗസ്റ്റ് 22, ശനിയാഴ്ച** **72-ാം നെഹ്‌റു ട്രോഫി** **ആലപ്പുഴ, പുന്നമടക്കായലിൽ**. ചെറുവള്ള ഹീറ്റുകൾ **11:00 AM IST** മുതൽ; ഉദ്ഘാടനം **2:00 PM**; ചുണ്ടൻ ഹീറ്റുകളും ഫൈനലും ഉച്ചയ്ക്ക് ശേഷം. മത്സരം തുടങ്ങുമ്പോൾ താഴെയുള്ള ചാനലുകൾ ബുക്ക്‌മാർക്ക് ചെയ്ത് «Nehru Trophy live» അല്ലെങ്കിൽ «വള്ളംകളി ലൈവ്» തിരയുക.',
        'കവറേജ് വർഷം തോറും വ്യത്യാസപ്പെടാം. **DD മലയാളം**യും **Asianet News**യും ആദ്യം തുറക്കുക; ബാക്കപ്പ് സ്ട്രീമിനായി മറ്റ് ന്യൂസ് ഡെസ്ക്കുകളും.',
      ],
      chips: ['YouTube സൗജന്യം', 'NTBR 2026', 'മലയാളം ലൈവ്', 'വള്ളംകളി', 'പുന്നമട'],
    },
    {
      type: 'videoList',
      title: 'പൊതുസംപ്രേഷണം — പ്രധാന സൗജന്യ സ്ട്രീമുകൾ',
      intro:
        'ദൂരദർശൻ പരമ്പരാഗത NTBR ടെലിവിഷൻ പങ്കാളി. DD മലയാളം, DD നാഷണൽ YouTube ചാനലുകൾ പുന്നമട ലൈവ് കവറേജ് നൽകിയിട്ടുണ്ട്.',
      videos: STREAMING_CHANNELS_PUBLIC_ML,
    },
    {
      type: 'videoList',
      title: 'മലയാളം ന്യൂസ് ചാനലുകൾ — ലൈവ് & ഹൈലൈറ്റുകൾ',
      intro:
        'NTBR ലൈവ് സ്ട്രീം ചെയ്യുകയോ അതേ ദിവസം ഹൈലൈറ്റ് പോസ്റ്റ് ചെയ്യുകയോ ചെയ്യുന്ന പ്രധാന കേരള ന്യൂസ് YouTube ഡെസ്ക്കുകൾ. മത്സര ദിവസം മുൻപ് സബ്സ്ക്രൈബ് ചെയ്യുക.',
      videos: STREAMING_CHANNELS_NEWS_ML,
    },
    {
      type: 'videoList',
      title: 'ടൂറിസം & ചാമ്പ്യൻസ് ബോട്ട് ലീഗ്',
      intro:
        'NTBR-ന് ശേഷം **ചാമ്പ്യൻസ് ബോട്ട് ലീഗ് (CBL)** കേരള കായലുകളിൽ തുടരുന്നു. ഔദ്യോഗിക ചാനലുകളിൽ ലീഗ് മത്സരങ്ങളും ടൂറിസം ഫിലിമുകളും.',
      videos: STREAMING_CHANNELS_TOURISM_ML,
    },
    {
      type: 'panel',
      title: 'NTBR 2026 — എപ്പോൾ ട്യൂൺ ഇൻ ചെയ്യാം (IST)',
      orderedList: [
        '**~11:00 AM** — ചെറുവള്ള വിഭാഗങ്ങളുടെ ഹീറ്റുകൾ (വെപ്പ്, ഇരുട്ടുകുത്തി, ചുരുളൻ…).',
        '**2:00 PM** — ഔദ്യോഗിക ഉദ്ഘാടനം; മുഖ്യമന്ത്രി V.D. Satheesan 72-ാം പതിപ്പ് ഉദ്ഘാടനം ചെയ്യും.',
        '**2:00 PM ശേഷം** — ചുണ്ടൻ ഹീറ്റുകൾ; ആറ് ഹീറ്റുകൾ, വേഗതയിൽ മുൻപുള്ളവ ഫൈനലിലേക്ക്.',
        '**~4:00 PM മുതൽ** — ഫൈനലുകൾ, ചുണ്ടൻ വള്ളം ചാമ്പ്യൻഷിപ്പ്.',
        '**മത്സരത്തിന് ശേഷം** — Asianet, Manorama, 24 News തുടങ്ങിയവയിൽ ഹൈലൈറ്റ് ക്ലിപ്പുകൾ.',
      ],
      callout:
        'ഖചിത ഹീറ്റ് സമയം nehrutrophy.nic.in-ൽ പരിശോധിക്കുക — പുന്നമടയിലെ കാലാവസ്ഥ/ജലനിലയിൽ മാറ്റം വരാം.',
    },
    {
      type: 'panel',
      title: 'സുഗമമായ സൗജന്യ സ്ട്രീമിംഗ് നുറുങ്ങുകൾ',
      list: [
        'മുകളിലെ YouTube ലിങ്കുകൾ തുറന്ന് **Subscribe** — മത്സര ദിവസം നോട്ടിഫിക്കേഷൻ.',
        'ചാനലിനുള്ളിൽ തിരയുക: «Nehru Trophy live», «NTBR 2026», «നെഹ്‌റു ട്രോഫി ലൈവ്».',
        'ഒരു സ്ട്രീം ലാഗ് ആണെങ്കിൽ ചാനൽ മാറ്റുക — Asianet, Manorama, DD മലയാളം പാരലൽ ഫീഡുകൾ.',
        'NIC **webcast.gov.in/nehrutrophy** ബ്രൗസർ ബാക്കപ്പ് — ലിസ്റ്റ് ചെയ്ത വർഷങ്ങളിൽ.',
        'ലൈവ് കഴിഞ്ഞ് ഹൈലൈറ്റുകൾ സൗജന്യം — «Nehru Trophy final» അടുത്ത ദിവസം തിരയുക.',
        'കോപ്പിറൈറ്റ്: പിരേസി റീബ്രോഡ്കാസ്റ്റ് ഒഴിവാക്കി ഔദ്യോഗിക ചാനൽ URL മാത്രം.',
      ],
    },
    {
      type: 'panel',
      title: 'YouTube-ൽ മറ്റ് കേരള വള്ളംകളികൾ',
      paragraphs: [
        'NTBR ശീർഷകമാണ്; അതേ ന്യൂസ് ചാനലുകൾ **വള്ളംകളി** കലണ്ടർ പൂർണ്ണം കവറേജ് ചെയ്യുന്നു. തീയതികൾ അടുത്തുവരുമ്പോൾ മുകളിലെ ചാനലുകളിൽ ഇവ തിരയുക:',
      ],
      list: [
        '**ചമ്പക്കുളം മൂലം വള്ളംകളി** — പമ്പാ; സീസൺ ഉദ്ഘാടനം.',
        '**പ്രസിഡന്റ്സ് ട്രോഫി** — കൊല്ലം; CBL സീസൺ ഫൈനൽ.',
        '**ആറന്മുള ഉത്രട്ടാഥി വള്ളംകളി** — പമ്പാ (2026 ഓഗ 30).',
        '**പായിപ്പാട് ജലോത്സവം**, **കുമരകം**, **ത്രിപ്രയാർ**, **കല്ലട** — ഓണം കാലത്തെ പ്രാദേശിക മത്സരങ്ങൾ.',
        '**ചാമ്പ്യൻസ് ബോട്ട് ലീഗ്** — കൈനകരി, തഴത്തങ്ങാടി, പുളിങ്കുന്ന്, കായംകുളം…',
      ],
    },
    {
      type: 'panel',
      title: 'എവിടെ നിന്നും മലയാളം കമന്ററി',
      paragraphs: [
        'അമേരിക്ക, യൂക്കെ, ഗൾഫ്, എവിടെ നിന്നും മലയാളികൾ പുന്നമട തീരത്തുള്ളവരെപ്പോലെ ഔദ്യോഗിക YouTube സ്ട്രീമുകൾ കാണാം — VPN വേണ്ടാത്ത ന്യൂസ് ചാനലുകൾ. **ഇംഗ്ലീഷ് പതിപ്പ്** അതേ ലിങ്കുകൾ ഇംഗ്ലീഷ് കുറിപ്പുകളോടെ.',
        '2026 ചുണ്ടൻ പട്ടികയും കാപ്റ്റൻ വിവരങ്ങളും **72-ാം നെഹ്‌റു ട്രോഫി ചുണ്ടൻ ഗൈഡ്**-ൽ. ചരിത്രവും സന്ദർശക നുറുങ്ങുകളും **കേരള വള്ളംകളി NTBR ഗൈഡ്**-ൽ.',
      ],
      callout: {
        text: 'ഇംഗ്ലീഷ് പതിപ്പ് വായിക്കുക →',
        url: '/blog/kerala-boat-race-live-stream-youtube-channels',
      },
    },
  ],
};
